import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4346dc0d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4346dc0d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346dc0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4346dc0d')) {
      api.createRecord('4346dc0d', component.options)
    } else {
      api.reload('4346dc0d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4346dc0d&scoped=true", function () {
      api.rerender('4346dc0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/viewDesign/index.vue"
export default component.exports